<button matTooltip="{{ 'shared.share-by-mail' | translate }}" class="gmail-icon" mat-mini-fab (click)="share()" aria-label="share with gmail">
  <mat-icon>mail</mat-icon>
</button>
